import DefaultSelect from '@hero/ui-kit/inputs/DefaultSelect';
import Form from '@hero/ui-kit/inputs/Form';
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { noop } from 'ts-essentials';
import * as yup from 'yup';

export const OutreachedByMeSchema = yup
    .object()
    .shape({
        outreached_by_me: yup.string().nullable()
    })
    .defined();

export type OutreachedByMeSchemaParams = yup.InferType<typeof OutreachedByMeSchema>;

const OutreachedByMeFilter: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    return (
        <Form
            validationSchema={OutreachedByMeSchema}
            submitFn={noop}
            defaultValues={{
                outreached_by_me: searchParams.get('outreached_by_me') || 'false'
            }}
        >
            <DefaultSelect
                styles={{ minWidth: '220px' }}
                name="outreached_by_me"
                onChange={(e) => {
                    const value = e.currentTarget.value;

                    setSearchParams((prevState) => {
                        if (value === 'false') {
                            prevState.delete('outreached_by_me');
                        } else {
                            prevState.set('outreached_by_me', value);
                        }

                        return prevState;
                    });
                }}
                options={[
                    { label: 'Outreached by Me', value: 'true' },
                    { label: 'All', value: 'false' }
                ]}
            />
        </Form>
    );
};

export default OutreachedByMeFilter;
